export default "__VITE_ASSET__Dfi7Sb7Q__"